import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { getFaqForSteamPage } from '@entities/faq';
import { Accordion } from '@shared/ui/organisms';
import { usePartner } from '@shared/lib/partner';
const FAQSectionContent: FC = () => {
  const {
    partner
  } = usePartner();
  return <FAQSectionContentWrapper>
      <Accordion size="s" items={getFaqForSteamPage(partner)} />
    </FAQSectionContentWrapper>;
};
export default FAQSectionContent;
const FAQSectionContentWrapper = /*#__PURE__*/styled('div')({
  name: "FAQSectionContentWrapper",
  class: "fstrw29",
  propsAsIs: false
});

require("./FAQSectionContent.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./FAQSectionContent.tsx");